



































































































































































































































import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { emptyToLine, splitThousands } from "@/utils/common";
import BtnCheckGroup from "@/components/scope/btn-check-group.vue";
import dayjs from "dayjs";
const customer = namespace("customer");
const user = namespace("user");
const app = namespace("app");
const base = namespace("base");
const marketing = namespace("marketing");
const setting = namespace("setting");

@Component({
  components: { BtnCheckGroup }
})
export default class ServiceEdit extends Vue {
  @app.Mutation setPBPX;
  @customer.Action getCustomerList;
  @customer.Action getCustomerDetail;
  @marketing.Action queryCardTemplateList;
  @marketing.Action queryCardTemplateDetail;
  @marketing.Action createCard;
  @base.Action getDictionaryList;
  @user.State userData;
  @app.State btnLoading;
  @app.Mutation btnStartLoading;
  @app.Mutation btnStopLoading;
  @setting.Action getPatternPaymentList;
  dayjs = dayjs;
  splitThousands = splitThousands;
  showPaymentMethod: boolean = false;
  paymentMethod: string = "";
  get breadData() {
    return [
      { name: this.$t("marketing.card-manage"), path: "/marketing/card" },
      { name: this.isAdd ? this.$t("marketing.open-card") : this.$t("marketing.open-card") }
    ];
  }
  get isAdd() {
    return this.$route.name === "cardOpen";
  }
  typeOptionsData: any = [
    {
      label: this.$t("marketing.Package-card"),
      value: "1"
    },
    {
      label: this.$t("marketing.Stored-value-Card"),
      value: "2",
      disable: true
    }
  ];
  payWayList: any[] = [];
  get orderType() {
    return this.$route.query.type;
  }
  get urlCustomerCode() {
    return this.$route.query.customerCode;
  }
  serviceList: any[] = [];
  emptyToLine = emptyToLine;
  showSelectCustomer: boolean = false;
  orderFormData: any = {
    cardType: "1", // 卡类型1：套餐卡 2：储值卡
    cardTemplateCode: "", // 套餐模板code
    activatedDate: dayjs().format("YYYYMMDD"), // 开卡日期
    customerCode: "",
    mobile: "",
    firstName: ""
  };
  cardTemplateList: any = [];
  serviceItemList: any[] = [];
  cardTemplateInfo: any = {};
  get orderId() {
    return this.$route.params.id;
  }
  showPaymentMethodModal() {
    if (this.checkAddData()) {
      this.showPaymentMethod = true;
    }
  }
  created() {
    this.setPBPX(52);
    this.init();
    this.getCardTemplateList();
  }
  async init() {
    this.getPatternPaymentList({
      status: "1"
    }).then(data => {
      this.payWayList = data.data || [];
    });
    if (this.urlCustomerCode) {
      this.setCustomerData("", this.urlCustomerCode);
    }
  }
  getCardTemplateList() {
    this.queryCardTemplateList({
      pageNum: 1,
      pageSize: 999
    }).then(data => {
      this.cardTemplateList = data.data.list;
    });
  }
  groupIndex: number = 1;
  handleCardTemplateChange(val) {
    this.groupIndex = 1;
    this.queryCardTemplateDetail({
      cardTemplateCode: val
    }).then(data => {
      data = data.data || {};
      data.serviceList.forEach(serviceItem => {
        if (serviceItem.partsList && serviceItem.partsList.length > 0) {
          serviceItem.isGroup = true;
          serviceItem.groupServiceIndex = this.groupIndex;
          serviceItem.partsList.forEach(partsItem => {
            data.partsList.push(
              Object.assign(partsItem, {
                isGroup: true,
                groupServiceIndex: this.groupIndex
              })
            );
          });
          this.groupIndex++;
        }
      });
      if (data.validPeriod === -1) {
        data.dateExpiry = this.$t("marketing.permanent");
      } else {
        data.dateExpiry = dayjs()
          .add(data.validPeriod, "d")
          .format("YYYY-MM-DD");
      }
      this.cardTemplateInfo = data;
    });
  }
  submitForm() {
    if (!this.paymentMethod) {
      this.$message.error("请选择付款方式");
    } else {
      this.addCard();
    }
  }
  checkAddData(): boolean {
    if (!this.orderFormData.cardTemplateCode) {
      this.$message.error("请先选择卡模板");
      return false;
    }
    if (!this.orderFormData.customerCode) {
      this.$message.error("请选择客户");
      return false;
    }
    return true;
  }
  addCard() {
    this.btnStartLoading();
    Object.assign(this.orderFormData, {
      paymentList: [
        {
          paidMethod: this.paymentMethod,
          paidAmount: this.cardTemplateInfo.cardAmount
        }
      ]
    });
    this.createCard(this.orderFormData)
      .then(data => {
        this.$message.success("开卡成功");
        this.$router.push(`/marketing/card-view/${data.data.cardCode}`);
      })
      .finally(() => {
        this.btnStopLoading();
      });
  }

  deleteItem(key, index) {
    console.log(key, index);
    this.orderFormData[key].splice(index, 1);
  }

  linkCreateCustomer() {
    let { href } = this.$router.resolve({
      path: `/setting/customer-add`
    });
    window.open(href, "_blank");
  }

  seletedCustomer: string = "";
  customerList: any[] = [];
  handleShowSelCustomer() {
    this.showSelectCustomer = true;
    this.$nextTick(() => {
      (this.$refs["select-customer"] as any).focus();
    });
  }
  handleSearchCustomer(val) {
    if (val) {
      this.getCustomerList({
        pageSize: 20,
        pageNum: 1,
        searchKey: val
      }).then(data => {
        if (!data.data.list) {
          this.customerList = [];
        } else {
          this.customerList = data.data.list.map(item => {
            item.label = `${item.plateCode}${item.customerName ? "/" + item.customerName : ""} ${
              item.mobile ? "/" + item.mobile : ""
            }`;
            return item;
          });
        }
      });
    } else {
      this.customerList = [];
    }
  }
  handleChooseCustomer(val) {
    const customer = this.customerList.find(item => {
      return val === item.vehicleCode;
    });
    this.setCustomerData(val, customer.customerCode);
  }
  setCustomerData(vehicleCode, customerCode) {
    this.orderFormData.customerCode = customerCode;
    this.getCustomerDetail({
      customerCode: customerCode,
      vehicleCode: vehicleCode
    }).then(data => {
      const customerData = data.data;
      if (!customerData.customerName || !customerData.mobile) {
        this.$confirm("开卡需要客户姓名和手机号，前去更新该用户信息？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            let { href } = this.$router.resolve({
              path: `/setting/customer-edit/${customerCode}?vehicleCode=${customerData.vehicleList[0].vehicleCode}`
            });
            window.open(href, "_blank");
          })
          .catch(() => {});
      } else {
        this.orderFormData.firstName = customerData.customerName;
        this.orderFormData.mobile = customerData.mobile;
      }
    });
  }
}
